import { Injectable } from '@angular/core';
import * as UIModels from '@shared-models/index';

@Injectable({
    providedIn: 'root'
})

/**
 * Session storage service
 */
export class SessionStorageService {
    constructor() { }

    setItem(key: UIModels.CE.StorageKeys | string, data: any): void {
        const stringData: string = JSON.stringify(data);
        sessionStorage.setItem(key, stringData);
    }

    getItem(key: UIModels.CE.StorageKeys | string): any {
        return JSON.parse(sessionStorage.getItem(key));
    }

    removeItem(key: UIModels.CE.StorageKeys | string): void {
        sessionStorage.removeItem(key);
    }

    clearAll(): void {
        sessionStorage.clear();
    }
}
